import React, {Component} from 'react';
import {Container} from './styles';
import Lixeira from '../../../../assets/emojis/lixeira/lixeira@3x.png';
import {IoMdClose} from 'react-icons/io';

export default class Apagar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            default: true,
            grupo: props.grupo,
            id: props.id
        }
    }

    render() {
        return (
            <Container>
                <div className="close">
                    <button 
                        onClick={() => this.props.closeModal()}>
                        <IoMdClose color="#fff" className="i-close" />
                    </button>
                </div>
                <img src={Lixeira} alt=""/>

                <h1>Apagar grupo {this.state.grupo}?</h1>

                <h5>Excluindo o grupo todos os itens que estão dentro dele também serão apagados.</h5>

                <div className="botoes">
                    <button 
                        onClick={() => this.props.confirm(this.state.id)}
                        className="confirm">
                        Excluir grupo
                    </button>
                    <button 
                        onClick={() => this.props.closeModal()}
                        className="cancel">
                        Cancelar
                    </button>
                </div>
            </Container>
        )
    }
}